import { connect } from 'react-redux'
import requestDataForEvents from '../../../../../actions/bookingCalendar/event/requestDataForEvents'
import { getIsFullyLoaded } from '../../../../../reducers/bookingCalendar/selectors/dates'
import { isUserLoading } from '../../../../../reducers/userAccount/selectors/userAccount'
import { markNotificationAsSeen } from '../../../../../actions/notification/notifications'
import { getNotificationsNotReadCount } from '../../../../../reducers/userAccount/selectors/notifications/getNotificationsCounts'
import { isOpen } from '../../../../../reducers/templates/selectors/modal'
import { getTaskBadge } from '../../../../../reducers/tasks/selectors'
import { getReservationsListNew } from '../../../../../reducers/reservationsList/selectors'
import { isInScope } from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'

function mapStateToProps(state) {
  const isAuthorizing = isUserLoading(state)

  const inScope = isInScope(state)

  const taskCount = String(
    Number(
      getNotificationsNotReadCount(state)
        ? getNotificationsNotReadCount(state)
        : 0,
    ) +
      Number(
        getTaskBadge(state) &&
          inScope([
            [
              PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING,
              PermissionScope.SCOPE_CAN_USE_TASKS_FOOD,
              PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS,
              PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING,
            ],
          ])
          ? getTaskBadge(state)
          : 0,
      ) +
      Number(
        getReservationsListNew(state).length &&
          inScope([PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS])
          ? getReservationsListNew(state).length
          : 0,
      ),
  )

  return {
    eventsFullyLoaded: getIsFullyLoaded(state),
    isAuthorizing,
    isTemplateModalOpen: isOpen(state),
    taskCount: taskCount, //We have to load events for everything
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadEvents: () => dispatch(requestDataForEvents()),
    markAsSeenAll: () => dispatch(markNotificationAsSeen('all')),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)
